import { render } from "./2016-12-03-Text Categorization Summary.md?vue&type=template&id=1527d29c"
const script = {}
script.render = render

export default script